import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Modal } from "reactstrap";
import OtpInput from "react-otp-input";
import "./styles.scss";
import API from "../../api/indexv2";
import { useDispatch } from "react-redux";
import { LOGIN } from "../../api/apiList";
import { handleError } from "../../components/common/utils";
import crossIcon from "../../images/cross-icon.svg";
import { notify } from "../../components/common/utils";
import { ToastContainer } from "react-toastify";
import LoaderWhite from "../../components/common/LoaderWhite";
import { loginUser } from "../../slices/userSlice";
import { fetchSellers } from "../../slices/sellerSlice";
import axios from "axios";
import BrandLogo from "../../images/home/kiko-logo.svg";

const Login = (props) => {
  const dispatch = useDispatch();
  const [mobile, setMobileNumber] = useState("");
  const [otpNew, setOtpNew] = useState("");
  const [otpOpen, setOtpOpen] = useState(false);
  const [requestOtpLoading, setRequestOtpLoading] = useState(false);
  const [otpVerifyLoading, setOtpVerifyLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
  const [countdown, setCountdown] = useState(30);
  const [resendDisable, setResendDisable] = useState(false);

  let sellerDetails = {};
  try {
    sellerDetails = JSON.parse(localStorage.getItem("sellerDetails"));
  } catch (error) {
    sellerDetails = null;
  }

  let timer;
  const startTimer = () => {
    timer = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown === 0) {
          clearInterval(timer);
          return 0;
        }
        return prevCountdown - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    if (otpOpen) {
      startTimer();
    }
    return () => {
      clearInterval(timer);
    };
  }, [otpOpen]);

  const getSellers = async (data) => {
    try {
      const latitude = defaultAddress?.latitude
      const longitude = defaultAddress?.longitude
      let payload =
      {
        areaCode: defaultAddress?.zipcode,
        category: "Grocery"
      }
      if (data?._id) {
        payload.userId = data?._id
      }
      if (latitude && longitude) {
        payload.latitude = latitude
        payload.longitude = longitude
      }
      dispatch(
        fetchSellers(payload)
      );
    } catch (error) {
      console.log("ERROR FETCH SELLER ", error);
    }
  };
  const verifyOtp = async () => {
    const obj = {
      loginType: "browser",
      screenType: "user",
      phone: `+91${mobile}`,
      countryCode: "+91",
      mobile: mobile,
      code: otpNew,
    };
    setOtpVerifyLoading(true);
    API.post(LOGIN, obj)
      .then(({ data }) => {
        setOtpVerifyLoading(false);
        if (data.status) {
          localStorage.setItem("user", JSON.stringify(data.user));
          localStorage.setItem("token", JSON.stringify(data.token));
          props.setModalIsOpen(false);
          if (props.isOpenFromCart) {
            props.onSuccess()
          }
          getSellers(data.user)
          dispatch(loginUser(data))
          setErrorMessage("");
        } else {
          setErrorMessage(data?.message);
          setOtpVerifyLoading(false);
          notify("error", "Please provide valid details");
        }
      })
      .catch((error) => {
        setOtpVerifyLoading(false);
        handleError(error);
      });
  };

  const requestOtp = (event, resend) => {
    if (resend) {
      event.preventDefault();
      if (countdown !== 0) {
        return;
      }
      setResendDisable(true)
    }
    else {
      if (sellerDetails?.mobile === mobile) {
        setErrorMessage(
          "Buyer and seller number should not be same please use another number"
        );
      }
    }
    if (mobile.length === 10) {
      setRequestOtpLoading(true);
      const options = {
        method: "post",
        url: `${process.env.REACT_APP_KIKO_API_BASE_URL}/request-otp-v2`,
        data: {
          phone: `+91${mobile}`,
        },
      };
      return axios(options)
        .then(({ data }) => {
          if (data) {
            if (data.success) {
              if (!resend) {
                setOtpOpen(true);
              }
              else {
                setResendDisable(false)
                clearInterval(timer);
                setCountdown(30);
                startTimer();
              }
            } else {
              notify("error", "Please provide valid details");
            }
            setRequestOtpLoading(false);
          } else {
            setRequestOtpLoading(false);
            throw new Error("Token data is missing");

          }
        })
        .catch((error) => {
          setRequestOtpLoading(false);
          handleError(error);
        });
    }
  };

  return (
    <>
      <ToastContainer />
      <Modal
        className="custom-modal-kl verify-login-modal-kl"
        isOpen={props.modalIsOpen}
        aria-labelledby="contained-modal-title-vcenter"
        contentLabel="Login Modal"
        centered
        toggle={() => {
          props.setModalIsOpen(false);
        }}
      >
        <img
          alt="Close"
          src={crossIcon}
          className="login-close-icon-kl"
          onClick={() => {
            props.setModalIsOpen(false);
          }}
        />
        <div className="custom-modal-body-kl text-center">
          <div>
            <img className="kiko-logo-kl" src={BrandLogo} alt="" />
            <div className="mobile-number-title-kl">
              Enter 10 Digit Mobile Number
            </div>
            <div className="enter-mobile-number-kl">
              <div className="country-number">
                +91
              </div>
              <input
                className="form-control"
                disabled={otpOpen ? otpOpen : false}
                type="number"
                pattern="[0-9]*"
                inputMode="numeric"
                maxLength="10"
                value={mobile === 0 ? "" : mobile}
                onChange={(event) => {
                  setMobileNumber(event.target.value);
                  setErrorMessage("");
                }}
                onKeyPress={(event) => {
                  if (event.target.value.length >= 10) {
                    event.preventDefault();
                  }
                }}
              />
            </div>
          </div>
          <div>
            {!otpOpen ? (
              <>
                <div className="button-loader-kl disabled">
                  <button
                    className="verify-otp-btn-kl"
                    type="button"
                    disabled={
                      requestOtpLoading || mobile.length < 10 || mobile === 0
                    }
                    onClick={(e) => {
                      requestOtp(e, false);
                    }}
                  >
                    {!requestOtpLoading && "Get OTP"}
                    {requestOtpLoading && <LoaderWhite />}
                  </button>
                </div>

                {errorMessage && <p className="error">{errorMessage}</p>}
              </>
            ) : (
              <>
                <div>
                  <div className="mobile-number-title-kl">
                    An OTP has been sent to your mobile Number please verify it
                    below
                  </div>
                  <div className="opt-form-kl">
                    <OtpInput
                      value={otpNew}
                      inputType="number"
                      onChange={(event) => {
                        setOtpNew(event);
                      }}
                      numInputs={6}
                      renderSeparator={<span></span>}
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>

                  <div className="received-otp-kl">
                    {countdown > 0 ? `Waiting for the OTP... ${countdown} sec.` : "Didn’t Receive OTP? "}
                    <button
                      className="resend-otp-btn-kl"
                      type="button"
                      disabled={countdown !== 0 || resendDisable}
                      onClick={(e) => {
                        requestOtp(e, true);
                      }}
                    >
                      RESEND OTP
                    </button>
                  </div>
                </div>
                <div className="button-loader-kl">
                  <button
                    type="button"
                    className="verify-otp-btn-kl"
                    disabled={
                      otpVerifyLoading || otpNew.length < 6 || otpNew === ""
                    }
                    onClick={() => {
                      verifyOtp();
                    }}
                  >
                    {!otpVerifyLoading && "VERIFY"}
                    {otpVerifyLoading && <LoaderWhite />}
                  </button>
                </div>
                {errorMessage && <div className="error-message-kl">{errorMessage}</div>}
              </>
            )}
          </div>
          <div className="term-service-text-kl">
            By continuing, you agree to our{" "}
            <a href="https://kikoshop.in/terms-and-condition/" target="_blank" rel="noopener noreferrer">
              Terms of service
            </a>
            {" & "}
            <a href="https://kiko.live/privacy-policy/" target="_blank" rel="noopener noreferrer">
              Privacy policy
            </a>
          </div>

        </div>
      </Modal>
    </>
  );
};
export default Login;
